import { BehaviorSubject, Observable  } from "rxjs";

export abstract class VideoPlayerComponentBase {
    protected _isPlaying: BehaviorSubject<boolean> = new BehaviorSubject(false);

    public get isPlaying(): boolean {
        return this._isPlaying.value;
    }

    public playingState(): Observable<boolean> {
        return this._isPlaying.asObservable();
    }
}
